module.exports = __webpack_public_path__ + "static/media/EditTaskIcon.e6e6edac.svg";